/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var _a = ezdia.config, COLLAPSE_GRID_WIDTH = _a.COLLAPSE_GRID_WIDTH, GRID_WIDTH_MARGIN = _a.GRID_WIDTH_MARGIN, HEADER_HEIGHT = _a.HEADER_HEIGHT;
    var GRID_ID = 'grid';
    var GRID_FORM_WARP_ID = 'ez-js-grid-form-wrapper';
    var FORM_INFO_PANEL_ID = 'ez-js-form-top-info-and-nav';
    var FORM_INFO_PANEL_PH_ID = FORM_INFO_PANEL_ID + "-placeholder";
    var FORM_CLOSE_BTN_ID = 'ez-js-form-right-close';
    var FORM_BTNS_CONTAINER_ID = 'updateBtnContainer';
    var FORM_TAB_WRAPPER_ID = 'ez-scroll-nav-pills';
    var UPDATE_FORM_ID = 'updateFrm';
    var IDS = ezdia.config.IDS;
    var DATA_ROW = '[data-row="row"]';
    var DATA_ROW_INPUT = '[data-row="input"]';
    var DATA_ACTION_MULTIPLE_VALUES = '[data-action="multiple values"]';
    var DATA_ACTION_RESET = '[data-action="reset"]';
    var GRID_FORM_ACTIVE_CLS = 'ez-grid-form-active';
    var GRID_FORM_FULL_CLS = 'ez-grid-form-full';
    var GRID_FORM_FIX_CLS = 'ez-grid-form-active-fixed';
    var FORM_SCROLL_EVENT = 'scroll.ez.formscroll';
    var FORM_CLICK_EVENT = 'click.ez.formclick';
    var TEMPLATES = ezdia.templates.form;
    var FORM_SPLIT_VIEW_STATUS = {
        enabled: 'enabled',
        disabled: 'disabled'
    };
    var NOT_READ_VIEW = new Set([
        'hidden',
        'html',
        'comment',
        'json',
        'attributes',
        'groupField',
        'inputlist'
    ]);
    function getHelperClass(column) {
        var editable = column.editable, edittype = column.edittype, config = column.config;
        var classes = 'has-feedback ';
        if (editable) {
            switch (edittype) {
                case 'singlechoice':
                case 'visualstatus':
                case 'status':
                case 'dropdown':
                case 'country':
                    if (config && !config.userInput) {
                        classes += 'has-feedback-select';
                    }
                    break;
                case 'multichoice':
                    classes += 'has-feedback-multichoice';
                    break;
                case 'creativebrief':
                    classes += 'has-feedback-creativebrief';
                    break;
                case 'inputlist':
                    classes += 'has-feedback-inputlist';
                    break;
                default:
                    break;
            }
        }
        return classes;
    }
    function getClasses(column) {
        var config = column.config, editable = column.editable, edittype = column.edittype, classes = column.classes, helperText = column.helperText, placeholder = column.placeholder;
        var cls = [];
        if (classes) {
            cls.push(classes);
        }
        if (config && config.videoHelp) {
            cls.push('has-video-feedback');
        }
        if (!editable) {
            cls.push('form-group-view');
            if (edittype === 'html') {
                cls.push('readonly-html');
            }
        }
        if (helperText || placeholder) {
            cls.push(getHelperClass(column));
        }
        return cls.join(' ');
    }
    var Form = /** @class */ (function () {
        function Form() {
            this.validateObj = {};
            this.briefObj = {};
            this.category = {};
            this.comment = {};
            this.isSplitView =
                localStorage.getItem('splitView') || FORM_SPLIT_VIEW_STATUS.enabled;
            this.setFullViewCls();
            this.bindBasicActions();
        }
        Form.prototype.renderItem = function (_a) {
            var e_1, _b;
            var selectedId = _a.ids, grid = _a.grid;
            this.initializeValue(selectedId);
            var pageParams = $.ezdia.config.pageParams;
            var colModel = pageParams.colModel;
            var GRID_DATA = ezdia.config.GRID_DATA;
            var rowData = GRID_DATA[grid][selectedId];
            $.ezdia.widgets.load(this.actiontype);
            try {
                for (var colModel_1 = __values(colModel), colModel_1_1 = colModel_1.next(); !colModel_1_1.done; colModel_1_1 = colModel_1.next()) {
                    var col = colModel_1_1.value;
                    var name_1 = col.name;
                    var value = this.formatValue(col, rowData[name_1]);
                    var colValObj = this.formatColModel(col, value);
                    var column = colValObj.column;
                    var groupName = column.groupName, config_1 = column.config, editable = column.editable;
                    var htmlContent = this.createFields(colValObj);
                    if (!htmlContent) {
                        continue;
                    }
                    if (this.groupArrayObj[groupName]) {
                        this.groupArrayObj[groupName].push(htmlContent);
                    }
                    else {
                        this.groupArrayObj.Default.push(htmlContent);
                    }
                    if (editable && config_1.showhistory) {
                        this.historyLinksArray.push(name_1);
                    }
                    if (editable && config_1.showParentValue) {
                        this.showParentValueArray.push(name_1);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (colModel_1_1 && !colModel_1_1.done && (_b = colModel_1.return)) _b.call(colModel_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.setFormTemplate(rowData);
            this.renderGroupsWithTabs(this.groupArrayObj);
            $.ezdia.desk.getMetaObj({
                ids: this.selectedId,
                widgets: {
                    brief: this.briefObj,
                    category: this.category,
                    comment: this.comment
                },
                share: true
            });
            $.ezdia.widgets.create(this.actiontype);
            this.actions();
            this.bindWidgets();
        };
        Form.prototype.show = function () {
            this.isShow = true;
            this.resetGridWidthAndForm();
        };
        Form.prototype.hide = function () {
            this.isShow = false;
            this.resetGridWidthAndForm(true);
        };
        Form.prototype.closeFormBtn = function (id) {
            if (id === void 0) { id = FORM_CLOSE_BTN_ID; }
            $("#" + id)
                .off(FORM_CLICK_EVENT)
                .on(FORM_CLICK_EVENT, this.resetGridWidthAndForm.bind(this, true));
        };
        Form.prototype.toggleFullView = function () {
            var frmw = $("#" + GRID_FORM_WARP_ID);
            if (this.isSplitView === FORM_SPLIT_VIEW_STATUS.disabled) {
                frmw.removeClass(GRID_FORM_FULL_CLS);
                this.isSplitView = FORM_SPLIT_VIEW_STATUS.enabled;
            }
            else {
                frmw.addClass(GRID_FORM_FULL_CLS);
                this.isSplitView = FORM_SPLIT_VIEW_STATUS.disabled;
            }
            localStorage.setItem('splitView', this.isSplitView);
            $("#" + FORM_TAB_WRAPPER_ID).scrollingNav('refresh');
        };
        Form.prototype.initializeValue = function (selectedId) {
            var _a = $.ezdia.config.pageParams, account = _a.account, role = _a.role, module = _a.module;
            this.selectedId = selectedId;
            this.actiontype = "FORM__" + selectedId;
            this.hideButtons = true;
            this.colModelArray = [];
            this.$form = $("#" + UPDATE_FORM_ID);
            this.groupArrayObj = this.getGroupArrayObj();
            this.historyLinksArray = [];
            this.showParentValueArray = [];
            this.validateObj = {};
            this.briefObj = {};
            this.category = {};
            ezdia.config.currentItem = {};
            ezdia.config.metadata = {};
            ezdia.config.JS.currentAccountKey = account + "." + role + "." + module + "." + selectedId;
        };
        Form.prototype.getGroupArrayObj = function () {
            var e_2, _a;
            var colGroup = $.ezdia.config.pageParams.colGroup;
            var groupArrayObj = {
                Default: []
            };
            this.groupIdMap = {};
            try {
                for (var colGroup_1 = __values(colGroup), colGroup_1_1 = colGroup_1.next(); !colGroup_1_1.done; colGroup_1_1 = colGroup_1.next()) {
                    var label = colGroup_1_1.value.label;
                    this.groupIdMap[label] = ezdia.util.makeId();
                    groupArrayObj[label] = [];
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (colGroup_1_1 && !colGroup_1_1.done && (_a = colGroup_1.return)) _a.call(colGroup_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return groupArrayObj;
        };
        Form.prototype.formatColModel = function (col, value) {
            var _a = $.ezdia.config.pageParams.commentFieldObj, cfName = _a.name, cfEditable = _a.editable;
            var column = __assign({}, col);
            var orginalConfig = column.config, helperText = column.helperText, placeholder = column.placeholder, name = column.name;
            var classes = getClasses(column);
            var fieldId = ezdia.util.makeId();
            var config = {};
            if (orginalConfig) {
                config = __assign({}, orginalConfig);
            }
            if (name === cfName) {
                column.editable = cfEditable;
            }
            var colObj = {
                value: value,
                id: fieldId,
                idSuffix: fieldId.split('__').pop(),
                column: __assign(__assign({}, column), { id: fieldId, config: config, helperText: helperText || placeholder, classes: classes })
            };
            this.colModelArray.push(column);
            ezdia.config.currentItem[column.name] = colObj;
            return colObj;
        };
        Form.prototype.formatValue = function (column, value) {
            var edittype = column.edittype;
            var retValue = value;
            if (edittype === 'date') {
                if (value) {
                    var year = value.split('-')[0];
                    if (year === '0000' || year === '9999' || year === '9998') {
                        retValue = '';
                    }
                }
            }
            return retValue;
        };
        Form.prototype.setFormTemplate = function (data) {
            var formTemplate = $.ezdia.config.pageParams.formTemplate;
            if (formTemplate) {
                var handlebarsT = Handlebars.compile(formTemplate);
                $('#ez-js-form-item-info').html(handlebarsT(data));
            }
        };
        Form.prototype.createFields = function (colValObj) {
            var column = colValObj.column, value = colValObj.value;
            var edittype = column.edittype, editable = column.editable, entity = column.entity, _a = column.config, validate = _a.validate, validateRules = _a.validate_rules;
            var formTemplate = $.ezdia.config.pageParams.formTemplate;
            var content;
            if (edittype === 'multiple') {
                if (!formTemplate) {
                    $('#ez-js-form-item-info').html(value);
                }
                return null;
            }
            if ((validate || validateRules) && editable && edittype !== 'inputlist') {
                $.ezdia.validate.init(this.validateObj, column);
            }
            if (!editable && !value) {
                return '';
            }
            if (!editable && value && !NOT_READ_VIEW.has(edittype) && !entity) {
                content = this.readonlyView(colValObj);
            }
            else {
                content = this.editableView(colValObj);
            }
            if (editable) {
                this.hideButtons = false;
            }
            if (edittype === 'creativebrief') {
                this.briefObj = {
                    // eslint-disable-next-line no-restricted-globals
                    name: name,
                    value: value
                };
            }
            else if (edittype === 'category') {
                this.category[column.name] = {
                    column: column,
                    value: value
                };
            }
            else if (edittype === 'comment') {
                $.ezdia.comment.init(this.comment, {
                    column: column,
                    value: value
                });
            }
            var htmlContent = TEMPLATES.rowMarkup(__assign(__assign({}, colValObj), { content: content }));
            $.ezdia.widgets.init(colValObj, this.actiontype);
            return htmlContent;
        };
        Form.prototype.readonlyView = function (colValObj) {
            var name = colValObj.column.name;
            var content = $.ezdia.inputs.readonlyView(colValObj, this.actiontype);
            if (name === 'id') {
                content += $.ezdia.inputs.hiddentext(colValObj);
            }
            return content;
        };
        Form.prototype.editableView = function (colValObj) {
            return $.ezdia.inputs.create(colValObj, this.actiontype);
        };
        Form.prototype.renderGroupsWithTabs = function (groupArrayObj) {
            var colGroup = $.ezdia.config.pageParams.colGroup;
            var _a = TEMPLATES.groupsWithTabsMarkup({
                colGroup: colGroup,
                groupArrayObj: groupArrayObj,
                groupIdMap: this.groupIdMap
            }), grpHTMLContent = _a.grpHTMLContent, tabsHtmlContent = _a.tabsHtmlContent;
            $('#content').html(grpHTMLContent);
            $('#ez-sys-form-tabs').html(tabsHtmlContent);
        };
        Form.prototype.bindWidgets = function () {
            this.setCurrentStatusValue();
            this.formButtons();
            if (!this.hideButtons) {
                $.ezdia.validate.create(this.validateObj, UPDATE_FORM_ID);
                this.$form.isDirty();
                this.localStorage();
            }
            this.setActivityTimer();
            recordActivityTime('start');
        };
        Form.prototype.setCurrentStatusValue = function () {
            var statusField = $.ezdia.config.pageParams.statusField;
            var value = (ezdia.config.currentItem[statusField] || {}).value;
            $.ezdia.config.pageParams.currentStatus = value;
            ezdia.config.pageParams.currentStatus = value;
        };
        Form.prototype.actions = function () {
            this.scrollingTabs();
            if (!this.hideButtons) {
                this.fieldsOptionsActions();
                this.showHistoryActions();
                this.showParentValueActions();
            }
        };
        Form.prototype.formButtons = function () {
            var btnContainer = $("#" + FORM_BTNS_CONTAINER_ID);
            if (!this.hideButtons) {
                btnContainer.show();
                $.ezdia.stickyFormBtns({
                    sticky: FORM_BTNS_CONTAINER_ID,
                    frm: UPDATE_FORM_ID
                });
            }
            else {
                btnContainer.hide();
            }
        };
        Form.prototype.localStorage = function () {
            this.$form.localStorage('destroy').localStorage({
                accountKey: ezdia.config.JS.currentAccountKey,
                cols: this.colModelArray
            });
        };
        Form.prototype.setActivityTimer = function () {
            var _a = $.ezdia.config.pageParams, dueDateField = _a.dueDateField, currentStatus = _a.currentStatus, userAccount = _a.userAccount, roleType = _a.roleType;
            if (currentStatus &&
                (currentStatus.indexOf('Assigned') !== -1 ||
                    currentStatus.indexOf('Saved') !== -1)) {
                if (!roleType && userAccount === 'ezdia') {
                    startActivityTimer(this.selectedId, dueDateField);
                }
            }
        };
        Form.prototype.scrollingTabs = function () {
            setTimeout(function () {
                $("#" + FORM_TAB_WRAPPER_ID).scrollingNav({
                    clickable: true,
                    offsets: ['ez-page-top-navbar', 'ez-js-form-top-info-and-nav']
                });
            }, 0);
            $('#ez-desk-form-actions-wrapper').show();
        };
        Form.prototype.fieldsOptionsActions = function () {
            $('[data-checkbox="devfieldOption"]').on('click', this.handelFieldOptionsMenu.bind(this));
            $("li" + DATA_ACTION_RESET).on('click', this.handelResetOptionsMenu.bind(this));
            // $(DATA_ACTION_MULTIPLE_VALUES).on('click', function() {
            //   var self = $(this);
            //   if (self.hasClass('disable')) {
            //     return;
            //   }
            //   self
            //     .closest('[data-row="row"]')
            //     .addClass('form-control-options-multiple')
            //     .removeClass('form-control-has-multiple-values');
            // });
        };
        Form.prototype.handelFieldOptionsMenu = function (event) {
            var input = event.target;
            var $input = $(input);
            var prefix = 'form-control-options-';
            var parent = $input.closest(DATA_ROW);
            var name = $input.data('id');
            var actiontype = $input.data('actiontype');
            var addCls = '';
            var removeCls = '';
            if (input.checked) {
                $input
                    .closest('li')
                    .addClass('active')
                    .siblings()
                    .removeClass('active')
                    .find('input[type="checkbox"]')
                    .prop('checked', false);
                if (actiontype === 'append') {
                    addCls = prefix + "append";
                    removeCls = prefix + "delete";
                }
                else {
                    addCls = prefix + "delete";
                    removeCls = prefix + "append";
                }
                parent.removeClass(removeCls);
                parent.addClass(addCls);
                this.resetMultiVal(parent);
            }
            else {
                $input.closest('li').removeClass('active');
                input.className = input.className.replace(/form-control-options-[a-zA-Z]+/g, '');
            }
            this.handelDeleteContent(actiontype, name);
            this.handelAppendContent(actiontype, name);
        };
        Form.prototype.handelResetOptionsMenu = function (event) {
            var input = event.currentTarget;
            var $input = $(input);
            var parent = $input.closest(DATA_ROW);
            var multiple = parent.data('multiple');
            var name = $input.data('name');
            var _a = ezdia.config.currentItem[name], id = _a.id, value = _a.value, column = _a.column;
            var type = column.edittype;
            var elem = $("#" + id);
            $input
                .closest('li')
                .siblings()
                .removeClass('active')
                .find('input[type="checkbox"]')
                .prop('checked', false);
            parent[0].className = parent[0].className.replace(/form-control-options-[a-zA-Z]+/g, '');
            this.handelDeleteContent('', name);
            this.handelAppendContent('', name);
            $.ezdia.quickAction.resetVales(type, name, elem, id, value);
            if (multiple) {
                this.resetMultiVal(parent);
            }
        };
        Form.prototype.handelDeleteContent = function (actiontype, name) {
            var id = ezdia.config.currentItem[name].id;
            var elem = $("#" + id);
            var deleteAction = elem.data('deleteAction');
            var parent = elem.closest(DATA_ROW_INPUT);
            var multiWrap = parent.find(DATA_ACTION_MULTIPLE_VALUES);
            if (actiontype === 'delete' && !deleteAction) {
                $.ezdia.quickAction.toggleDisableFields(elem, true);
                multiWrap.addClass('disable');
            }
            else if (deleteAction) {
                $.ezdia.quickAction.toggleDisableFields(elem, false);
                multiWrap.removeClass('disable');
            }
        };
        Form.prototype.handelAppendContent = function (actiontype, name) {
            var _a = ezdia.config.currentItem[name], id = _a.id, value = _a.value;
            var elem = $("#" + id);
            var appendAction = elem.data('appendAction');
            var parent = elem.closest('[data-row="input"]');
            var type = parent.data('type');
            if (actiontype === 'append' && !appendAction) {
                if (type === 'tag') {
                    $.each(value.split(','), function each(index, val) {
                        elem.tagsinput('remove', val);
                    });
                }
                else {
                    $.ezdia.quickAction.resetVales(type, name, elem, id, '');
                }
                elem.data('appendAction', true);
            }
            else if (appendAction) {
                $.ezdia.quickAction.resetVales(type, name, elem, id, value);
                elem.data('appendAction', false);
            }
            elem.trigger('cusappend');
        };
        Form.prototype.resetMultiVal = function (elem) {
            elem
                .removeClass('form-control-options-multiple')
                .addClass('form-control-has-multiple-values');
        };
        Form.prototype.showHistoryActions = function () {
            var e_3, _a;
            var length = this.historyLinksArray.length;
            if (!length) {
                return;
            }
            var currentItem = ezdia.config.currentItem;
            try {
                for (var _b = __values(this.historyLinksArray), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var name_2 = _c.value;
                    var colObj = currentItem[name_2];
                    var idSuffix = colObj.idSuffix;
                    var link = $("#" + IDS.SHOW_HISTORY_PREFIX + idSuffix);
                    link.history(__assign(__assign({}, colObj), { selectedId: this.selectedId }));
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        Form.prototype.showParentValueActions = function () {
            var e_4, _a;
            var length = this.showParentValueArray.length;
            if (!length) {
                return;
            }
            var currentItem = ezdia.config.currentItem;
            try {
                for (var _b = __values(this.showParentValueArray), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var name_3 = _c.value;
                    var colObj = currentItem[name_3];
                    var idSuffix = colObj.idSuffix;
                    var link = $("#" + IDS.SHOW_PARENTVALUE_PREFIX + idSuffix);
                    link.parentValue(__assign(__assign({}, colObj), { selectedId: this.selectedId }));
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        };
        Form.prototype.bindBasicActions = function () {
            $("#ez-js-form-enable-split-view")
                .off(FORM_CLICK_EVENT)
                .on(FORM_CLICK_EVENT, this.toggleFullView.bind(this));
        };
        Form.prototype.setFullViewCls = function () {
            if (this.isSplitView === FORM_SPLIT_VIEW_STATUS.disabled) {
                $("#" + GRID_FORM_WARP_ID).addClass(GRID_FORM_FULL_CLS);
            }
        };
        Form.prototype.fixFormInfo = function (frmw) {
            frmw.addClass(GRID_FORM_FIX_CLS);
            var outerH = $("#" + FORM_INFO_PANEL_ID).outerHeight(true);
            $("#" + FORM_INFO_PANEL_PH_ID).css('height', outerH);
            this.triggerEvent();
        };
        Form.prototype.unFixFormInfo = function (frmw) {
            frmw.removeClass(GRID_FORM_FIX_CLS);
            $("#" + FORM_INFO_PANEL_PH_ID).css('height', 0);
            this.triggerEvent(true);
        };
        Form.prototype.bindScroll = function () {
            var _this = this;
            var win = $(window);
            var frmw = $("#" + GRID_FORM_WARP_ID);
            var isFormFixed = false;
            win.off(FORM_SCROLL_EVENT).on(FORM_SCROLL_EVENT, function () {
                var formtop = frmw.offset().top;
                var wintop = win.scrollTop();
                if (formtop - wintop <= HEADER_HEIGHT) {
                    if (!isFormFixed) {
                        isFormFixed = true;
                        _this.fixFormInfo(frmw);
                    }
                }
                else {
                    isFormFixed = false;
                    _this.unFixFormInfo(frmw);
                }
            });
        };
        Form.prototype.scrollToForm = function () {
            this.bindScroll();
            $('html,body').animate({
                scrollTop: $("#" + GRID_FORM_WARP_ID).offset().top - HEADER_HEIGHT
            }, 500);
        };
        Form.prototype.unbindScroll = function () {
            $(window).off(FORM_SCROLL_EVENT);
            var frmw = $("#" + GRID_FORM_WARP_ID);
            this.unFixFormInfo(frmw);
        };
        Form.prototype.resetGridWidthAndForm = function (isHideForm) {
            var _this = this;
            var gridFormW = $("#" + GRID_FORM_WARP_ID);
            if (!gridFormW.length) {
                return;
            }
            var grid = $("#" + GRID_ID);
            var gridWidth = COLLAPSE_GRID_WIDTH;
            if (isHideForm) {
                grid.jqGrid('setGridParam', { formActive: false });
                gridWidth = $(document).width() - GRID_WIDTH_MARGIN;
                gridFormW.removeClass(GRID_FORM_ACTIVE_CLS);
                grid.jqGrid('resetSelection');
                this.unbindScroll();
                ezdia.component.quickActions.resetQuickActionLink();
            }
            else {
                grid.jqGrid('setGridParam', { formActive: true });
                $('.ui-jqgrid-bdiv').scrollLeft(0);
                gridFormW.addClass(GRID_FORM_ACTIVE_CLS);
                setTimeout(function () {
                    _this.scrollToForm();
                }, 0);
            }
            grid.jqGrid('setGridWidth', gridWidth, false);
        };
        Form.prototype.triggerEvent = function (detach) {
            var _a = ezdia.config.CUS_EVENTS, FORM_EVENT_FREE = _a.FORM_EVENT_FREE, FORM_EVENT_STICK = _a.FORM_EVENT_STICK;
            var event = detach ? FORM_EVENT_FREE : FORM_EVENT_STICK;
            $(document).trigger(event);
        };
        return Form;
    }());
    var component;
    (function (component) {
        component.form = new Form();
    })(component = ezdia.component || (ezdia.component = {}));
})(ezdia || (ezdia = {}));
